import { ERROR_MESSAGES } from '../constants';

export const getErrorMessageByCode = (
  errorCode: number,
  lang: string
): string | null => {
  const messages = ERROR_MESSAGES[errorCode];
  return messages ? messages[lang] || null : null;
};
